<template>
  <div id="app" v-cloak>
    <router-view></router-view>

    <transition-group name="popup" tag="div">
      <div :key="popupStatus" class="popup-model" v-if="popupStatus">
        <div class="popup-bg" @click="closePopup"></div>
        <div class="popup">
          <div class="pop-wrapper">
            <div class="pop-header">
              {{ popuptype === 'login' ? '登入' : '忘記密碼' }}
            </div>
            <div class="pop-content">

              <!-- LOGIN -->
              <Login v-if="popuptype === 'login'"></Login>
              <ForgetPassword v-if="popuptype === 'fg'"></ForgetPassword>

            </div>
          </div>
          <div class="pop-close" @click="closePopup">x</div>
        </div>
      </div>
    </transition-group>

    <!--Loading-->
    <div class="loading" 
      v-if="pageLoadingStatus" 
      :class="{'isShow': pageLoadingStatus === true}">
      <div class="spinner_double">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>

    <footer id="footer"> OneAD © {{ new Date().getFullYear() }}. All rights reserved </footer>
    
  </div>
</template>

<script>

import { 
  mapGetters,
  mapActions,
 } from 'vuex';

import Login from './components/login/Login';
import ForgetPassword from './components/login/Forgetpassword';

export default {
  name: 'app',
  components: {
    Login,
    ForgetPassword,
  },
  created() {
    if (localStorage.getItem('access_token')) {
      this.actionUserLoginIn();
    } else {
      this.actionUserLoginOut();
    }
  },
  metaInfo() {
    return {
      title: 'OneBrandMaster 品牌廣告戰情室',
      meta: [
        { name: 'og:title', content: 'OneBrandMaster 品牌廣告戰情室' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      popuptype: 'getPopupType',
      popupStatus: 'getPopupStatus',
      pageLoadingStatus: 'pageLoadingStatus', 
      userStatus: 'getUserLoginStatus',
    }),
  },
  methods: {
    ...mapActions([
      'resetUserStatus',
      'actionUserLoginIn',
      'actionUserLoginOut',
      'togglePopupStatus',
      'changePopupType',
    ]),

    // 只要關閉表單，會清除所有使用者狀態資料和過程。
    closePopup() {
      this.togglePopupStatus(); // 顯示/隱藏表單
      this.changePopupType(''); // 重置表單內容
      this.resetUserStatus();   // 重置使用者登入和忘記密碼表單狀態
    },
  },
};

</script>

<style lang="scss">

@import '/styles/global';
@import '/styles/variables';
@import '/styles/grid';
@import '/styles/btns';

html {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

*, 
*::before, 
*::after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;

  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
}

body {
  width: 100%;
  min-height: 100vh;
  &.overflow_hidden {
    overflow: hidden;
  }
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

a {
  text-decoration: none;
}

input {
  border: none;
  outline: none;
}

input,
select {
  padding: 0;
  &:focus {
    outline: none;
  }
}

#app {
  display: flex;
  flex-direction: column;

  margin: 0 auto;
  width: 100%;
  min-height: 100vh;
}

#footer {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  width: 100%;
  height: 35px;

  background-color: #333;
  color: #fff;
  font-size: 14px;
}

[v-cloak]{
  display: none;
}

// loading 
.loading {
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  background-color:rgba(0,0,0,.3);

  transition: all, .3s;
  z-index: -1;
}

.loading.isShow {
  opacity: 1;
  z-index: 9999;
}

@import '/styles/common/loading/double';

.popup-enter-active, 
.popup-leave-active {
  transition: all .3s;
  
}
.popup-enter, 
.popup-leave-active {
  opacity: 0;
}

.popup-model {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: auto;
  min-width: 400px;
  max-width: 400px;
  min-height: auto;
  background-color: #fff;
  border-radius: 4px;
  transform: translate(-50%, -50%);
  .pop-wrapper {
    position: relative;
    width: 100%;
    height: auto;
    .pop-header {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      height: 50px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
      font-weight: 600;
      color: #e89022;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 1px;
        background-color: #e89022;
      }
    }
    .pop-content {
      margin: 100px auto;
    }
  }
  .pop-close {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 10px;
    width: 45px;
    height: 45px;
    color: #999;
    font-size: 20px;
    cursor: pointer;
    
  }
}

.popup-bg {
  position: absolute;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
}

@media screen and (max-width: 768px) {
  .popup-bg {
    display: none;
  }
  .popup {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    min-width: 100%;
    transform: translate(0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?08b94553